const en = {
  i18n: {
    language: 'English (US)',
    shortLang: 'Eng',
    locale: 'en'
  },
  homeLogin: {
    chooseHowToSignIn: 'Sign in',
    tryTheGame: 'Ready to fight?',
    quickStart: 'Quick Start',
    signUp: 'Sign up',
    signIn: 'Sign in',
    back: 'Back',
    submit: 'Submit',
    logInWithEmail: 'Log in with email',
    signUpWithEmail: 'Sign up with email',
    emailInputPlaceholder: 'Your Email',
    passwordInputPlaceholder: 'Your Password',
    passwordConfirmInputPlaceholder: 'Confirm Password',
    passwordSetNewInputPlaceholder: 'Create Password',
    keepMeLoggedIn: 'Keep me logged in',
    titleForgotPassword: 'Forgot password',
    passwordRecovery: 'Password Recovery',
    passwordRecoverySubtitle: 'Enter your email and we\'ll send you password recovery instructions.',
    rulesDescription: 'I agree to the Terms of service and I have read and understood the Privacy Policy.',
    emailError: 'The email must be a valid email address',
    passwordError: 'Password must have at least 8-32 characters',
    errorPasswordsDoesNotMatch: 'Passwords does not match',
    emailSentTitle: 'Email sent',
    emailSentSubtitle: 'If the account exists, an email containing further instructions has been sent.',
    orYouCan: 'or you can',
  },
  nav: {
    intro: 'Nethernite Intro',
    video: 'What is Nethernite?',
    game_modes: 'Game Modes',
    leaderboard: 'Leaderboard',
    play_now: 'Play Now!'
  },
  homeHeader: {
    title: {
      first: 'Welcome to the',
      second: 'World of Nethernite'
    },
    promoText: 'Join an awesome action battle of unique Monsters! Lead your team to battles, overcome the challenges, and earn exclusive rewards! Expand your army and enjoy many victories in this exciting <br /> <b>Turn-based Battle RPG</b>',
    promoCaption: 'Turn-based Battle RPG',
    buttonPlay: 'Play Now!',
    additionally: {
      first: 'Play through tutorial and get Monster after first battle.'
    },
    bottomCaption: 'discover the world',
    bottomDown: 'scroll down'
  },
  slides: {
    monsters: {
      title: 'Monsters',
      subtitle: 'Assemble the greatest force ever seen',
      description: 'Choose your heroes, create powerful teams, fight through an exciting campaign against bosses and other players!',
      footer_title: 'Nethernite Wiki',
      footer_description: 'The wisdom on evolutions is hidden on the pages of NetherniteWiki.<br/> Learn all the features of the Monsters in your team and discover what other creatures can be found in Nethernite. Your knowledge about races and abilities are crucial for succeeding in the game!',
      type_name: 'Monsters',
      type_name_descr: 'Collect them all',
      btn_text: 'Start Battle',
    },
    arena: {
      title: 'Arena',
      subtitle: 'Walk the path from a beginner to champion',
      description: 'Boost the might of your warriors, defeat enemies, get rewards and experience!',
      footer_title: 'BUILD YOUR OWN META-TEAM!',
      footer_description: 'Boost the might of your warriors, defeat enemies, get rewards and experience!',
      type_name: 'Arena',
      type_name_descr: 'Start Battle',
      btn_text: 'Start Battle',
    },
    altar: {
      title: 'Altar',
      subtitle: 'Evolve your legendaries',
      description: 'Upgrade and level up Monsters to achieve victory!',
      footer_title: 'Levels of difficulty',
      footer_description: 'Fight Bosses! Defeat extremely powerful Monsters.<br/> At new levels, the Boss becomes stronger, rewards get better, and entry conditions are higher. Only the bravest one dare to challenge!',
      type_name: 'Altar',
      type_name_descr: 'Prove your dominance',
      btn_text: 'Start Battle',
    },
    leaderboard: {
      title: 'Leaderboard',
      subtitle: 'Only the bravest dare to challenge each other',
      description: 'Climb the rankings in intense arena battles and get special prizes. Reach the top!',
      footer_title: 'Types of monsters rarity',
      footer_description: 'Descend into the mysterious Nethernite Dungeon!<br/> Meet the Wandering Merchant to get unique rare items.<br/> Choose 5 your best Monsters and fight for the treasures of the immortal ghosts!<br/> How far can you go?',
      type_name: 'Leaderboard',
      type_name_descr: 'Fight for treasures',
      btn_text: 'Start Battle',
    },
    // altar: {
    //   title: 'Altar',
    //   description: 'You can get the souls of unnecessary monsters by disenchanting them to dust. Craft random monsters from the resource Soul Dust. Cross identical monsters moving to the next level of rarity.',
    //   footer_title: 'Types of monsters rarity',
    //   footer_description: 'In Altar you can craft or upgrade monsters to any level of rarity - Base, Common, Uncommon and Rare!',
    //   type_name: 'Altar',
    //   type_name_descr: 'Upgrade monsters',
    //   btn_text: 'Fight!',
    // },
    // marketplace: {
    //   title: 'Marketplace',
    //   description: 'Global Nethernite\'s market with it\'s own currency designed for buying and selling monsters. Use it to fill your team with even stronger characters!',
    //   footer_title: 'TRADE SYSTEM',
    //   footer_description: 'Trade monster cards with your friends or other Nethernite universe dwellers to complete your collection. ',
    //   type_name: 'Marketplace',
    //   type_name_descr: 'Buy and sell monsters',
    //   btn_text: 'Fight!',
    // },
    // modes_leaderboard: {
    //   title: 'Nethernite Leaderboard',
    //   description: 'Nethernite Battle Seasons with a real rating, awards and leagues. Raise your rating and get up the ladder proving that you are the best!',
    //   footer_title: 'Leagues',
    //   footer_description: 'Depending on the rating, players are distributed in leagues - Bronze, Silver, Gold. The higher the league is, the higher the rewards and more difficult opponents are!',
    //   type_name: 'Season Rating',
    //   type_name_descr: 'Battleground'
    // },
    // modes_achievements: {
    //   title: 'Season Achievements',
    //   description: 'In the leaderboard there are Seasonal Achievements in various disciplines, for which rewards are given for top players. Become the best and get rare rewards!',
    //   footer_title: 'Rewards for the Best Players',
    //   footer_description: 'Defeat as many bosses and monsters as possible, cause the most damage and gain experience, earn the most coins and win more often than others in ranked battles. Get generous rewards for these setoff!',
    //   type_name: 'Season Achievements',
    //   type_name_descr: 'Battleground'
    // }
  },
  play_now: {
    play_now: 'Play now and get',
    pet_name: 'ROYAL GRIFFIN!',
    description: 'Play through tutorial and get Monster after first battle.'
  },
  video: {
    title: 'Start your journey to Nethernite glory!',
    descr: 'Discover an amazing World inhabited by all sorts of unusual creatures.<br /> Choose your heroes, create powerful teams to fight through an exciting campaign against powerful bosses and other players!<br/> Would you be the best with your unique collection of Nethernite Monsters?',
  },
  footer: {
    sitemap: 'Sitemap',
    contactUs: 'Contact Us',
    pp: 'Privacy Policy',
    cp: 'Cookie Policy',
    ToS: 'Terms of Service',
    api: 'Api',
    copyright: 'Nethernite© 2021',
    join_us: 'FOLLOW US'
  },
};

export default en
